import { DEFAULT_COUNTRY_ID } from '../../Constants';
import { COMPLETE_BOOKING, CREATE_BOOKING, LOAD_BOOKING } from '../booking/booking/action-types';
import { SUCCESS } from '../constants';
import { UPDATE_DETAILS } from './action-types';

const initialState = {
  details: DEFAULT_COUNTRY_ID,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPLETE_BOOKING:
      return {
        ...state,
        bookings: undefined,
        details: DEFAULT_COUNTRY_ID,
      };
    case UPDATE_DETAILS:
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.key]: action.payload.value,
        },
      };
    case CREATE_BOOKING + SUCCESS:
    case LOAD_BOOKING:
      return {
        ...state,
        details: initialState.details,
      };
    default:
      return state;
  }
};

export default reducer;
